import { Button } from '@mantine/core';
import { useIntl } from 'react-intl';

import { addressValidationMessages } from './address-validation-messages';

type ValidateButtonProps = {
  isAddressComplete: boolean;
  isValidating: boolean;
  onValidate: () => void;
};

export const ValidateButton = ({ isAddressComplete, isValidating, onValidate }: ValidateButtonProps) => {
  const intl = useIntl();
  return (
    <Button disabled={!isAddressComplete || isValidating} loading={isValidating} onClick={onValidate} variant='tertiary'>
      {intl.formatMessage(addressValidationMessages.validateButton)}
    </Button>
  );
};
